/**
 * @category Date format
 *
 * @summary Show duration in seconds as Xm Xs / Xh Xm / Xd Xh Xm / Xd Xh / Xd Xm / Xd
 *
 * @param {number} durationInSeconds - The duration to format in seconds
 *
 * @example
 * console.log(formatDuration(244)); // 4m 4s (z minutos y segundos)
 * console.log(formatDuration(300)); // 5m (z minutos)
 * console.log(formatDuration(3600)); // 1h (y horas)
 * console.log(formatDuration(4200)); // 1h 10m (y horas z minutos)
 * console.log(formatDuration(86400)); // 1d (x días)
 * console.log(formatDuration(90000)); // 1d 1h (x días y horas)
 * console.log(formatDuration(87000)); // 1d 10m (x días z minutos)
 * console.log(formatDuration(93840)); // 1d 2h 4m (x días y horas z minutos)
 */
var formatDuration = function formatDuration(durationInSeconds) {
  var totalMinutes = Math.floor(durationInSeconds / 60);
  if (totalMinutes < 60) {
    var remainingSeconds = Math.ceil(durationInSeconds - totalMinutes * 60);
    if (remainingSeconds === 0) {
      return "".concat(totalMinutes, "m");
    }
    return "".concat(totalMinutes, "m ").concat(remainingSeconds, "s");
  }
  var totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 24) {
    var _remainingMinutes = Math.ceil(totalMinutes - totalHours * 60);
    if (_remainingMinutes === 0) {
      return "".concat(totalHours, "h");
    }
    return "".concat(totalHours, "h ").concat(_remainingMinutes, "m");
  }

  // Calculate days and remaining time components
  var days = Math.floor(totalHours / 24);
  var remainingHours = totalHours % 24;
  var remainingMinutes = totalMinutes % 60;

  // Build the result string based on available components
  var result = "".concat(days, "d");
  if (remainingHours > 0) {
    result += " ".concat(remainingHours, "h");
  }
  if (remainingMinutes > 0) {
    result += " ".concat(remainingMinutes, "m");
  }
  return result;
};
export default formatDuration;